<template>
  <details>
    <summary class="pointer" :class="noselect ? 'noselect' : ''">{{summary}}</summary>
    <div class="content">
      <slot></slot>
    </div>
  </details>
</template>

<script>
export default {
  props: {
    summary: {
      type: String,
      default: 'spoiler'
    },
    noselect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.content {
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 19px;
  padding-left: 19px;

  border: 1px solid #ddd;
  border-top-color: rgb(221, 221, 221);
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: rgb(221, 221, 221);
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: rgb(221, 221, 221);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: rgb(221, 221, 221);
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;

  border-radius: 2px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>